import React from 'react';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <section className="py-24 px-4 bg-[#FBF8F4]" data-id="element-175">
      <div className="max-w-xl mx-auto text-center" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-10 md:p-14 rounded-3xl shadow-sm border border-[#EBE5DB] relative overflow-hidden" data-id="element-177">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#5A7D60]" data-id="element-178" />

          <span className="inline-block text-[#5A7D60] font-medium tracking-wider text-sm uppercase mb-6" data-id="element-179">
            Precio de lanzamiento
          </span>

          <div className="mb-6" data-id="element-180">
            <span className="text-2xl text-[#5C4A3A]/50 line-through" data-id="element-181">
              47 €
            </span>
          </div>

          <div className="mb-6" data-id="element-182">
            <span className="font-serif text-5xl md:text-6xl text-[#3D3229] font-bold" data-id="element-183">
              47 €
            </span>
          </div>

          <p className="text-lg text-[#5C4A3A] font-medium mb-4" data-id="element-184">
            Pack completo de 10 e-books
          </p>

          <div className="flex justify-center" data-id="element-185">
            <div className="w-16 h-px bg-[#EBE5DB]" data-id="element-186" />
          </div>

          <p className="text-[#5C4A3A]/70 mt-4 text-sm" data-id="element-187">
            Pago único · Acceso inmediato · Sin suscripciones
          </p>
        </motion.div>
      </div>
    </section>;
}